import type { TabDef } from '../../util_components/page_tabs/page_tabs';
import { resolveTabIn, searchWithTabFor } from '../../util_components/page_tabs/page_tabs';

export type ErcTab = 'checklist' | 'rules';

export const ERC_DEFAULT_TAB: ErcTab = 'checklist';

const ALL_TABS: TabDef<ErcTab>[] = [
  { id: 'checklist', label: 'Checklist' },
  { id: 'rules', label: 'Generation rules' }
];

// Rules (generation config) is SUPER_USER-only, so it is absent otherwise.
export const ercTabList = (canEditRules: boolean): TabDef<ErcTab>[] =>
  ALL_TABS.filter((t) => t.id !== 'rules' || canEditRules);

export const resolveErcTab = (search: string, canEditRules: boolean): ErcTab =>
  resolveTabIn(ercTabList(canEditRules), ERC_DEFAULT_TAB, search);

export const searchWithErcTab = (search: string, tab: ErcTab): string =>
  searchWithTabFor(ERC_DEFAULT_TAB, search, tab);
